"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.closeOverlay = closeOverlay;
exports.openOverlay = openOverlay;
exports.updateOverlay = updateOverlay;
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.some.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.filter.js");
var _overlay = _interopRequireDefault(require("../../overlay/overlay"));
var _context = require("./context");
var _functional = require("../../utils/functional");
var defaultConfig = {
  zIndex: 2000,
  duration: 0.3,
  className: '',
  customStyle: {},
  onChange: null
};
var overlay;

// close popup when click overlay && closeOnClickOverlay is true
function onClickOverlay() {
  if (_context.context.top) {
    var vm = _context.context.top.vm;
    vm.$emit('click-overlay');
    if (vm.closeOnClickOverlay) {
      if (vm.onClickOverlay) {
        vm.onClickOverlay();
      } else {
        vm.close();
      }
    }
  }
}
function updateOverlay() {
  if (!overlay) {
    overlay = (0, _functional.mount)(_overlay.default, {
      on: {
        click: onClickOverlay
      }
    });
  }
  if (_context.context.top) {
    var _context$top = _context.context.top,
      vm = _context$top.vm,
      config = _context$top.config;
    var el = vm.$el;
    if (el && el.parentNode) {
      el.parentNode.insertBefore(overlay.$el, el);
    } else {
      document.body.appendChild(overlay.$el);
    }
    Object.assign(overlay, defaultConfig, config, {
      show: true
    });
  } else {
    overlay.show = false;
  }
  overlay.onChange && overlay.onChange(overlay.show);
}
function openOverlay(vm, config) {
  if (!_context.context.stack.some(function (item) {
    return item.vm === vm;
  })) {
    _context.context.stack.push({
      vm: vm,
      config: config
    });
    updateOverlay();
  }
  return overlay;
}
function closeOverlay(vm) {
  var stack = _context.context.stack;
  if (stack.length) {
    if (_context.context.top.vm === vm) {
      stack.pop();
      updateOverlay();
    } else {
      _context.context.stack = stack.filter(function (item) {
        return item.vm !== vm;
      });
    }
  }
  return overlay;
}